import React, { useEffect } from 'react'; 
import { Link } from 'react-router-dom';
import Header from'../Component/Header'
const Curriculum = () => {  
    useEffect(() => {
        document.title = 'Curriculum - Sacread Heart Kharagpur';  
    }, []);  
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>Curriculum</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Curriculum</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                     <ul className="list newlist">
                     <li>Pupils are prepared for the ICSE & ISC (Commerce) Examination (Indian Council for Secondary Education Delhi) </li>
                     <li>In addition to the subjects prescribed by the council syllabus, the curriculum includes Religious instruction, (for Christians), Moral Science (for Non Catholics) and Value Education (for all) as compulsory subjects. </li> <li>Apart from these the curriculum may include Handicrafts, Singing, Project Work etc. </li>
                     <li>Bengali or Hindi as Second Language is taught from Class-V. </li>
                     <li>Selection and charge of subjects should be done only at the beginning of the academic year. It will not be permitted during the year. Classes IX-X should have same subjects for 2 years </li>
                     </ul>
 </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Curriculum

